export default __webpack_public_path__ + "static/media/aiSecurityRealcase.0cf49aee.jpg";